export const getOrganizationFromHostname = (): string | undefined => {
  const host = window.location.hostname;
  if (host.endsWith("smartmerchandiser.net")) {
    return host.split(".")[0];
  } else if (host.endsWith("localhost")) {
    return process.env.REACT_APP_DEFAULT_ORGANIZATION_SSO;
  }
  return undefined;
};

export const isLogoutPage = (): boolean => {
  const hash = window.location.hash;
  const pathname = window.location.pathname;
  const href = window.location.href;
  return (
    hash === "#/logout" ||
    hash === "#/auth0-error" ||
    pathname === "/logout" ||
    href.includes("/logout") ||
    href.includes("/auth0-error")
  );
};
